import React from "react";
import ReactDOM from "react-dom";

import Button from "./components/formElements/button/Button";
import Modals from "./components/uiElements/modal/Modal";

const UserConfirmation = (message, callback) => {
  const container = document.createElement("div");
  container.setAttribute("custom-confirmation-navigation", "");
  document.body.appendChild(container);
  const closeModal = callbackState => {
    ReactDOM.unmountComponentAtNode(container);
    document.body.removeChild(container);
    callback(callbackState);
  };

  ReactDOM.render(
    <Modals modalIsOpen={true}>
      <p className="font-weight-bold d-inline">Unsaved Changes</p>
      <button
        onClick={() => closeModal(false)}
        type="button"
        className="close float-right d-inline"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div className="row border-bottom pr-0 pl-0 mt-2"></div>
      <p
        className="pt-3"
        style={{
          color: "inherit",
        }}
      >
        {message}
      </p>
      <div className="row border-bottom pr-0 pl-0"></div>

      <div className="d-flex justify-content-between align-items-center mt-2">
        <Button
          onClick={() => {
            closeModal(true);
          }}
          label="Continue"
          className=" mr-3"
        />
        <Button
          type="outline"
          label="Cancel"
          onClick={() => closeModal(false)}
          className="btn-block"
        />
      </div>
    </Modals>,
    container
  );
};

export default UserConfirmation;
